export default __webpack_public_path__ + "static/media/culinary_topic.630a4b9a.jpg";